import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { useAuth } from "../../contexts/AuthContext";

export default function MarketingNav() {
  const { user, logout } = useAuth();
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // Close the mobile menu whenever the route changes.
  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  const links = [
    { label: "Product", to: "/product" },
    { label: "Find leads", to: "/lead-generation" },
    { label: "Case studies", to: "/case-studies" },
    { label: "Reply Agent", to: "/reply-agent" },
    { label: "Pricing", to: "/pricing" },
    { label: "Book a demo", to: "/book-demo" },
    { label: "Alternatives", to: "/alternatives" },
    { label: "Docs", to: "/docs" },
  ];

  return (
    <header
      className={`sticky top-0 z-50 transition-all duration-300 ${scrolled || open
          ? "bg-[#faf6ee]/85 backdrop-blur border-b border-[#e3dccb]"
          : "bg-transparent border-b border-transparent"
        }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 sm:py-4 flex items-center justify-between gap-3">
        <Link to="/" className="flex items-center gap-2 shrink-0">
          <img
            src="/collavue-logo-256.png"
            alt="Collavue home"
            width="64"
            height="64"
            className="w-12 h-12 sm:w-16 sm:h-16 rounded-md object-cover"
          />
        </Link>

        <nav className="hidden lg:flex items-center gap-4 xl:gap-7 text-sm text-[#1c2a4d]">
          {links.map((l) => (
            <Link key={l.to} to={l.to} className="hover:text-[#2d5bff] transition-colors">
              {l.label}
            </Link>
          ))}
        </nav>

        <div className="flex items-center gap-3 sm:gap-6">
          {user ? (
            <>
              <Link
                to="/dashboard"
                className="hidden sm:inline text-sm text-[#1c2a4d] hover:text-[#2d5bff]"
              >
                Dashboard
              </Link>
              <button
                type="button"
                onClick={() => logout({ redirectTo: "/" })}
                className="px-4 py-2 rounded-md bg-[#0a1736] text-white text-sm font-medium hover:bg-[#1c2a4d] transition-colors"
              >
                Sign out
              </button>
            </>
          ) : (
            <>
              <Link
                to="/login"
                className="hidden sm:inline text-sm text-[#1c2a4d] hover:text-[#2d5bff]"
              >
                Sign in
              </Link>
              <Link
                to="/signup"
                className="px-4 py-2 rounded-md bg-[#0a1736] text-white text-sm font-medium hover:bg-[#1c2a4d] transition-colors"
              >
                Sign Up
              </Link>
            </>
          )}
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            className="lg:hidden p-2 rounded-md text-[#1c2a4d] hover:bg-[#efe9db] transition-colors"
            aria-label={open ? "Close menu" : "Open menu"}
            aria-expanded={open}
          >
            {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </div>

      {open && (
        <nav className="lg:hidden border-t border-[#e3dccb] bg-[#faf6ee]/95 backdrop-blur px-4 py-3">
          <ul className="flex flex-col">
            {links.map((l) => (
              <li key={l.to}>
                <Link
                  to={l.to}
                  className="block px-2 py-2.5 text-sm text-[#1c2a4d] hover:text-[#2d5bff] transition-colors"
                >
                  {l.label}
                </Link>
              </li>
            ))}
            <li className="mt-1 pt-2 border-t border-[#e3dccb] sm:hidden">
              {user ? (
                <Link
                  to="/dashboard"
                  className="block px-2 py-2.5 text-sm text-[#1c2a4d] hover:text-[#2d5bff]"
                >
                  Dashboard
                </Link>
              ) : (
                <Link
                  to="/login"
                  className="block px-2 py-2.5 text-sm text-[#1c2a4d] hover:text-[#2d5bff]"
                >
                  Sign in
                </Link>
              )}
            </li>
          </ul>
        </nav>
      )}
    </header>
  );
}
